import React, { useEffect } from 'react';
import { withRouter } from 'react-router';
import { Translation } from 'react-i18next';
import { Table } from 'antd';

import { pathTo } from '../../../Routes';
import QueryString from '../../../../../lib/QueryString';
import Logger from '../../../../../lib/Logger';
import { mixpanelEventsEnum } from '../../../../../lib/Mixpanel';

const CognitoFormsAdminList = ({
  component,
  page,
  limit,
  order,
  filter,
  total,
  load,
  partnershipId,
  history,
  columns,
  trackerActions,
  ...props
}) => {
  const pagination = {
    current: page,
    pageSize: limit,
    total: total,
    showSizeChanger: false,
    position: ['bottomCenter'],
  };

  const handleTableChange = (pagination, filters, sorter) => {
    trackerActions(
      mixpanelEventsEnum.ACTIONS_PARTNER.COGNITO_FORMS_ADMIN_SEARCH,
      {
        sorterField: (Array.isArray(sorter) ? sorter[0] : sorter)?.field,
        sorterOrder: (Array.isArray(sorter) ? sorter[0] : sorter)?.order,
        ...Object.fromEntries(
          Object.entries(filters || {})
            .filter(([k, v]) => Array.isArray(v) && v.length > 0)
            .map(([k, v]) => [k, v.join(',')])
        ),
        paginationCurrent: pagination['current'],
      }
    );

    let path = props.location.pathname;
    const params = {};

    // handle pagination
    if ('current' in pagination && pagination['current']) {
      path = pathTo(component, { page: pagination['current'] });
    }

    // handle sorting
    if ('field' in sorter && 'order' in sorter) {
      if (sorter['field'] && sorter['order']) {
        const order =
          sorter['field'] +
          '.' +
          (sorter['order'] === 'ascend' ? 'asc' : 'desc');
        params['order'] = order;
      }
    }

    // handle filters
    if (filters) {
      for (const key in filters) {
        if (filters[key]) {
          params[key] = filters[key].join(',');
        }
      }
    }

    history.push(QueryString.append(path, params));
  };
  const filterString = JSON.stringify(filter);
  useEffect(() => {
    load(partnershipId, page, limit, order, JSON.parse(filterString));
  }, [partnershipId, page, limit, order, filterString, load]);

  return (
    <Translation>
      {(t) => (
        <Table
          className='cognito-form-admin-list-table'
          dataSource={props.list}
          columns={columns}
          pagination={page === 1 && total < limit ? false : pagination}
          loading={props.isLoading}
          scroll={{ x: true }}
          onChange={handleTableChange}
        />
      )}
    </Translation>
  );
};

export default withRouter(CognitoFormsAdminList);

Logger.log('silly', `CognitoFormsAdminList loaded.`);
